import { Container, TileTable, TileWrapper, SnowflakeBone } from './styled';
import { Bones } from '@simplywallst/ui-core';

const TileSkeleton = () => (
  <TileWrapper colLg={3} colMd={4} colSm={6} col={12}>
    <Container>
      <SnowflakeBone />
      <TileTable>
        <colgroup>
          <col width="50%" />
        </colgroup>
        <thead>
          <tr>
            <th colSpan={3}>
              <Bones maxWidth="30%" />
              <Bones maxWidth="60%" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span>Price</span>
              <Bones maxWidth="80%" />
            </td>
            <td>
              <span>7D</span>
              <Bones maxWidth="80%" />
            </td>
            <td>
              <span>1Y</span>
              <Bones maxWidth="80%" />
            </td>
          </tr>
          <tr>
            <td>
              <span>Mkt Cap</span>
              <Bones maxWidth="80%" />
            </td>
            <td>
              <span>P/E</span>
              <Bones maxWidth="80%" />
            </td>
            <td>
              <span>Growth</span>
              <Bones maxWidth="80%" />
            </td>
          </tr>
        </tbody>
      </TileTable>
    </Container>
  </TileWrapper>
);

export default TileSkeleton;
